module.exports = __webpack_public_path__ + "img/loading.02f936b9.svg";